import { generateCSS } from 'Common/components/Form';

const stylesGenerator = () => ({
  base: generateCSS({})
});

export default stylesGenerator;
